// Events are prefixed automatically by QuickAnswersAnalyticsProvider
export const QUICK_ANSWERS_EVENTS = {
  DRAWER_OPENED: "Drawer Opened",
  DRAWER_CLOSED: "Drawer Closed",
  DRAWER_RESIZED: "Drawer Resized",
  QUESTION_ASKED: "Question Asked",
  QUESTION_ANSWERED: "Question Answered",
  QUESTION_ABORTED: "Question Aborted",
  QUESTION_CLEARED: "Question Cleared",
  ERROR_RETRY_CLICKED: "Error Retry Clicked",
  FEEDBACK_GIVEN: "Feedback Given",
  ADDITIONAL_FEEDBACK_GIVEN: "Additional Feedback Given",
  COPY_CLICKED: "Copy Clicked",
  XLSX_DOWNLOAD: "XLSX Download",
  TABLE_GENERATION_STEPS_TOGGLED: "Table Generation Steps Toggled",
} as const

export type QuickAnswersEventName = typeof QUICK_ANSWERS_EVENTS[keyof typeof QUICK_ANSWERS_EVENTS]
